import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {ErrorStateMatcher } from '@angular/material/core';
import {Router} from '@angular/router';
import {Subcategory} from 'src/app/models/subcategory';
import {FrontDeskService} from 'src/app/services/front-desk.service';
import {TaxService} from 'src/app/services/tax.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-front-desk',
  templateUrl: './front-desk.component.html',
  styleUrls: [ './front-desk.component.scss' ]
})
export class FrontDeskComponent implements OnInit {

  public searchForm: FormGroup;
  public matcher = new FormErrorStateMatcher();
  public spinner: boolean
  public memberExist: number = 0;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'name' ];

  public dataSourceAllMembers: MatTableDataSource<any>
  public displayedColumnsAllMembers: string[] = [ 'name', 'cpf' ];

  //autocomplete
  //public entityForm: FormGroup;
  // public searchMemberControl: FormControl;
  //public members: any[] = []
  //public flagSelected: boolean = false;
  //

  constructor (
    private _taxService: TaxService,
    public _frontDeskService: FrontDeskService,
    private _formBuilder: FormBuilder,
    private router: Router
  ) {

    this.searchForm = this._formBuilder.group({
      cpf: new FormControl('', [ Validators.required ])
    });

    // this.getDolarCotation()

  }

  ngOnInit () {

  }

  applyFilter (filterValue: string) {
    this.dataSourceAllMembers.filter = filterValue.trim().toLowerCase();
  }

  getDolarCotation () {
    this._taxService.getById("4OC9uJyuX740nKeTDkOJ")
      .subscribe((result) => {
        this._frontDeskService.dolarCotation = Number(result.data().value)
      })
  }

  getMemberByCPF () {
    this.memberExist = 0

    if (this.searchForm.valid) {

      const cpf = this.searchForm.controls.cpf.value

      this._frontDeskService.getMemberByCPF(cpf)
        .subscribe((result) => {

          if (result.docs.length > 0) {
            this.memberExist = 1

            let memberArray: any[] = []
            let subCategoryArray: Subcategory[] = [];

            result.forEach((item) => {

              //console.log(">>>>>>>>>>>>>>>>>>>> " + item.data().shortName)

              let member = {
                'id': item.id,
                'name': item.data().name,
                'shortName': item.data().shortName ? item.data().shortName : item.data().name,
                'email': item.data().email,
                'annuity_from': item.data().annuity_from,
                'cellPhone': item.data().cellPhone,
                'cpf': item.data().cpf,
                'subCategory': item.data().subCategory,
                'crm': item.data().crm,
                'obs': item.data().obs,
                'balance': item.data().balance,
                'situation': item.data().situation
              }
              memberArray.push(member)

              let subCategory = item.data().subCategory
              subCategoryArray.push(subCategory)

            })

            this.dataSource = new MatTableDataSource(memberArray);

          } else {
            this.memberExist = 2
          }

        })
    }

  }

  selectedMember (member) {
    //console.log("member: " + JSON.stringify(member))
    this._frontDeskService.currentMember = member;
    this.router.navigate([ 'front-desk-member' ]);
  }

  createNewMember () {
    console.log("new member")
    this.router.navigate([ 'front-desk-register' ]);
  }

  loadAllMembers () {
    this.spinner = true

    this._frontDeskService.loadAllMembers()
      .subscribe((result) => {

        let allMembers: any[] = []

        result.forEach((item) => {

          if (!item.payload.doc.data().deleted) {

            if (item.payload.doc.data().name && item.payload.doc.data().name != 'A DEFINIR' && item.payload.doc.data().name != 'Abecadail') {

              //item.payload.doc.data().subCategory && !item.payload.doc.data().subCategory.sponsor

              //console.log(item.payload.doc.id)
              //console.log(item.payload.doc.data().name)
              //console.log(item.payload.doc.data().subCategory.sponsor)

              allMembers.push({
                'id': item.payload.doc.id,
                'name': item.payload.doc.data().name,
                'shortName': item.payload.doc.data().shortName ? item.payload.doc.data().shortName : '',
                'email': item.payload.doc.data().email,
                'cellPhone': item.payload.doc.data().cellPhone,
                'cpf': item.payload.doc.data().cpf,
                'crm': item.payload.doc.data().crm,
                'situation': item.payload.doc.data().situation,
                'balance': item.payload.doc.data().balance,
                'subCategory': item.payload.doc.data().subCategory
              })

            }

          }

        })
        this.spinner = false;
        this.dataSourceAllMembers = new MatTableDataSource(allMembers);

      })
  }


  tabClick (tab) {

    if (tab.index == 1) {
      this.loadAllMembers()
    }

  }

}
